import { HeaderBanner } from 'components/general-settings/header-banner/HeaderBanner'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_HEADER_BANNER } from 'services/apiHeaderBanner'
import { convertErrorMessage, formatDateMoment, uploadFileToS3 } from 'utils/utils'
import moment from 'moment'
import { Alert } from 'avo-ui'
import {
    ACTIVE_TIME_FIELD_NAME,
    GET_ITEM_FIELD_NAME,
    INITIAL_STATE,
    GET_FIELD_NAME,
    ITEM_FIELD_NAME_DETAIL,
} from 'configs/general-settings/configFormHeaderBanner'

export const HeaderBannerContainer = () => {
    const [reload, setReload] = useState(false)
    const [headerBannersDetail, setHeaderBannersDetail] = useState(INITIAL_STATE)
    const copyItems = [...(headerBannersDetail?.header_banners || [])]
    const [isLoadingUpload, setIsLoadingUpload] = useState(false)
    const [errorForm, setErrorForm] = useState({})
    const { fetching: getUrlHeaderBanners } = useFetch(API_HEADER_BANNER.URL_HEADER_BANNER)
    const { fetching: getHeaderBannersDetail, isLoading } = useFetch(API_HEADER_BANNER.DETAIL)
    const { fetching: updateHeaderBanners, isLoading: isUpdating } = useFetch(API_HEADER_BANNER.UPDATE)

    const onChangeForm = (item) => {
        setHeaderBannersDetail({ ...headerBannersDetail, ...item })
    }

    const setItems = (items) => {
        setHeaderBannersDetail({ ...headerBannersDetail, header_banners: items })
    }

    const onChangeItem = (e) => {
        const { name, value, index } = e
        copyItems[index][name] = value
        if (ACTIVE_TIME_FIELD_NAME?.includes(name) && !copyItems[index]?.published_time) {
            copyItems[index]['published_time'] = '00:00'
        }
        if (name === 'published_date' && !value) copyItems[index]['published_time'] = null
        setItems(copyItems)
    }

    const onAddNewItem = () => {
        setItems([
            ...copyItems,
            {
                desktop_image_url: null,
                mobile_image_url: null,
                url: null,
                published_date: null,
                published_time: null,
            },
        ])
    }

    const setUploadBanners = async (filesName, uploadDetail) => {
        const newHeaderBanners = [...headerBannersDetail?.header_banners]

        try {
            const s3Urls = await getUrlHeaderBanners({ files: filesName })
            const apiS3list = s3Urls?.data?.map(async (item, i) => {
                await uploadFileToS3(item, uploadDetail[i]?.file)
                newHeaderBanners[uploadDetail[i]?.index] = {
                    ...newHeaderBanners[uploadDetail[i]?.index],
                    [uploadDetail[i]?.key]: `${item?.url}${item?.fields?.key}`,
                }
            })
            await Promise.all(apiS3list)
            onSave({ ...headerBannersDetail, header_banners: newHeaderBanners })
        } catch (err) {
            console.log('upload failed')
        }

        setIsLoadingUpload(false)
    }

    const validateForm = () => {
        const validateHeaderBanners = () => {
            const result = []
            headerBannersDetail?.header_banners?.map((item, index) => {
                Object.keys(item).forEach((key) => {
                    if (GET_ITEM_FIELD_NAME[key] && !item[key]) {
                        result.push({ index, key, message: `${GET_ITEM_FIELD_NAME[key]} wajib diisi` })
                    }
                })
            })
            return result
        }

        return new Promise((resolve, reject) => {
            const errors = {}
            Object.keys(headerBannersDetail).forEach((key) => {
                if (GET_FIELD_NAME[key] && headerBannersDetail[key]?.length === 0) {
                    errors[key] = `${GET_FIELD_NAME[key]} wajib diisi`
                } else if (GET_FIELD_NAME[key] && validateHeaderBanners()?.length) {
                    errors['header_banners_detail'] = validateHeaderBanners()
                }
            })

            setErrorForm(errors)
            if (!Object.keys(errors).length) resolve()
        })
    }

    const onSubmit = () => {
        validateForm().then(async () => {
            const banners = [...headerBannersDetail?.header_banners]
            const uploadDetail = []
            const filesName = []

            const mapBannerImages = (name, file, index, key) => {
                filesName.push(name?.replace(/\s/g, ''))
                uploadDetail.push({ file, key, index })
            }

            banners.map((item, index) => {
                if (item?.desktop_image_url?.name) {
                    mapBannerImages(
                        item?.desktop_image_url?.name,
                        item?.desktop_image_url?.file,
                        index,
                        'desktop_image_url',
                    )
                }

                if (item?.mobile_image_url?.name) {
                    mapBannerImages(
                        item?.mobile_image_url?.name,
                        item?.mobile_image_url?.file,
                        index,
                        'mobile_image_url',
                    )
                }
            })

            if (filesName.length) {
                setIsLoadingUpload(true)
                await setUploadBanners(filesName, uploadDetail)
            } else {
                onSave()
            }
        })
    }

    const onSave = (payload = { ...headerBannersDetail }) => {
        const newPayload = {
            ...payload,
            header_banners: payload?.header_banners?.map((item, index) => {
                const { published_date, published_time, ...itemRest } = item
                const published_at = `${published_date} ${published_time}`
                return {
                    ...itemRest,
                    published_at: published_date ? moment(published_at).utc().format('YYYY-MM-DD HH:mm') : null,
                    sequence: index,
                }
            }),
        }
        updateHeaderBanners(newPayload)
            .then(() => {
                setReload(!reload)
                return Alert({
                    icon: 'success',
                    title: 'Success',
                    message: 'Header Banner Updated !',
                })
            })
            .catch((error) => setErrorForm(convertErrorMessage(error?.data, GET_FIELD_NAME, ITEM_FIELD_NAME_DETAIL)))
    }

    useEffect(() => {
        getHeaderBannersDetail().then((response) => {
            const { banners, ...dataRest } = { ...response?.data }
            const newDetail = {
                ...dataRest,
                header_banners: banners?.map((item) => {
                    const { published_at, ...itemRest } = item
                    const publishedAt = published_at ? formatDateMoment(published_at, 'YYYY-MM-DD HH:mm') : null
                    const splitPublishedAt = publishedAt?.split(' ')
                    return {
                        ...itemRest,
                        published_date: splitPublishedAt?.[0] || null,
                        published_time: splitPublishedAt?.[1] || null,
                    }
                }),
            }
            setHeaderBannersDetail(newDetail)
        })
    }, [reload])

    const props = {
        isShow: headerBannersDetail?.is_show,
        items: copyItems,
        setItems,
        onChangeForm,
        onChangeItem,
        onAddNewItem,
        errorForm,
        isLoading,
        isLoadingUpload,
        isUpdating,
        onSubmit,
    }

    return <HeaderBanner {...props} />
}
